const GetProperty = {
  methods: {
    getProperty(property, object = this.l10n, lang = this.lang) {
      const findLanguage = Object.values(object).find((item) => item.lang === lang)
      if (findLanguage) {
        return findLanguage[property]
      } else {
        return '\u2014'
      }
    },
  },
}

export default GetProperty
